import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { Hook } from './components/Hook';
import { PainPoints } from './components/PainPoints';
import { Method } from './components/Method';
import { Outcomes } from './components/Outcomes';
import { Deliverables } from './components/Deliverables';
import { Offer } from './components/Offer';
import { Faq } from './components/Faq';
import { Guarantee } from './components/Guarantee';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-cream font-sans" data-id="element-0" data-mp="2mjpw3ffpleft">
      <UrgencyBar data-id="element-1" data-mp="31bs09botatln" />
      <main data-id="element-2" data-mp="31c9u61o04vqe">
        <Hero data-id="element-3" data-mp="31ctdnmtavs6j" />
        <Hook data-id="element-4" data-mp="31cjk5p91r2w3" />
        <PainPoints data-id="element-5" data-mp="2wka0gqyiyz29" />
        <Method data-id="element-6" data-mp="2wjqkvgwckmre" />
        <Outcomes data-id="element-7" data-mp="2wj8g1vvmd07v" />
        <Offer data-id="element-8" data-mp="2wip2ssgwz006" />
        <Deliverables data-id="element-9" data-mp="2wi5m1f302hnq" />
        <Faq data-id="element-10" data-mp="28tw5osok2m3z" />
        <Guarantee data-id="element-11" data-mp="28tmi1bqzgr1g" />
      </main>
      <Footer data-id="element-12" data-mp="28sl3uyeo7ofi" />
    </div>;
}